<div class="rick-and-morty-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Rick and Morty App</p>
    <div class="hero-layout">
      <div>
        <h1>Rick and Morty App</h1>
        <div class="meta-badges">
          <span>Android</span>
          <span>Kotlin</span>
          <span>MVP</span>
          <span>REST API</span>
        </div>
      </div>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Rick and Morty App is a Kotlin Android application that fetches Rick and Morty data
        from the public Rick and Morty API.
      </p>

      <ul class="feature-list">
        <li>Connect to the public Rick and Morty API.</li>
        <li>Browse data from the series in a focused mobile experience.</li>
        <li>Use the MVP architectural pattern for a clear separation of responsibilities.</li>
      </ul>

      <a class="project-link" target="_blank" rel="noopener"
         href="https://github.com/jawegielewski/Rick-And-Morty-App">
        View on GitHub
      </a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/rick_and_morty_screenshot1.png"
           alt="Rick and Morty screenshot 1">
      <img class="phone-shot" src="../../../../assets/images/rick_and_morty_screenshot2.png"
           alt="Rick and Morty screenshot 2">
    </aside>
  </div>
</div>
